module.exports = __webpack_public_path__ + "img/inactive-12.41ada9f2.svg";